import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'formWizard2',
  setup(__props) {

const customHorizontal = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/customHorizontal.vue"))
const businessVertical = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/businessVertical.vue"))
const customVertical = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/customVertical.vue"))
const businessHorizontal = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/businessHorizontal.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Layout",
      title: "Step Form Wizard"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(customHorizontal)),
        _createVNode(_unref(businessVertical)),
        _createVNode(_unref(customVertical)),
        _createVNode(_unref(businessHorizontal))
      ])
    ])
  ], 64))
}
}

})